import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useDebugOptions } from "../DebugOptions";
import { DebugType } from "../DebugType";
import { DebugPopoverInner } from "./DebugPopoverInner";
export function DebugPopover(props) {
    const { type = DebugType.Debug } = props, restProps = __rest(props, ["type"]);
    const options = useDebugOptions();
    const showDebug = options[type] === true;
    if (!showDebug) {
        return _jsx(Fragment, {});
    }
    return _jsx(DebugPopoverInner, Object.assign({}, restProps, { type: type }));
}
//# sourceMappingURL=DebugPopover.js.map